import { render, staticRenderFns } from "./CreateKlasifikasi.vue?vue&type=template&id=0cd05c59&scoped=true"
import script from "./CreateKlasifikasi.vue?vue&type=script&lang=js"
export * from "./CreateKlasifikasi.vue?vue&type=script&lang=js"
import style0 from "./CreateKlasifikasi.vue?vue&type=style&index=0&id=0cd05c59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd05c59",
  null
  
)

export default component.exports